import { Injectable, inject } from '@angular/core';
import { ConsumerPortalApiService } from './consumer-portal-api.service';
import { Observable, map } from 'rxjs';
import { ContactResponse } from '../admin/interfaces/find-email.interface';
import { AssignOrRevokePermissionRequest, FeatureMapUserAccount } from '../admin/interfaces/user-accout.interface';

export interface CreateAccountContactRequest {
    firstName: string;
    lastName: string;
    email?: string;
    phone?: string;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerService {
    private readonly consumerPortalApiService = inject(ConsumerPortalApiService);

    /**
     * Get customer/account contacts
     * @param customerId
     * @returns Observable<ContactResponse[]>
     */
    getCustomerContacts(customerId: string): Observable<ContactResponse[]> {
        return this.consumerPortalApiService.get(`consumers/account/${customerId}/contacts`).pipe(
            map(res => {
                return res;
            })
        ) as unknown as Observable<ContactResponse[]>;
    }

    /**
     * Create a customer/account contact
     * @param accountId
     * @param body
     * @returns Observable<ContactResponse>
     */
    createAccountContact(accountId: string, body: CreateAccountContactRequest): Observable<ContactResponse> {
        return this.consumerPortalApiService.add(`consumers/account/${accountId}/contacts`, '', body) as unknown as Observable<ContactResponse>;
    }

    /**
     * assign or revoke permission
     * @param request
     * @returns Observable<FeatureMapUserAccount>
     */
    updateCustomerContactPermissions(request: AssignOrRevokePermissionRequest): Observable<FeatureMapUserAccount> {
        return this.consumerPortalApiService.patch<AssignOrRevokePermissionRequest>(`user-accounts/assign/permissions`, {}, request).pipe(
            map(res => {
                return res;
            })
        ) as unknown as Observable<FeatureMapUserAccount>;
    }

    /**
     * Activate or deactivate a contact via its dedicated endpoint
     * @param customerId account id
     * @param contactId GAPI contact id
     * @param isActive true to activate, false to deactivate
     * @returns Observable
     */
    setContactActiveStatus(customerId: string, contactId: string, isActive: boolean): Observable<unknown> {
        const action = isActive ? 'activate' : 'deactivate';
        return this.consumerPortalApiService.post<unknown>({ controller: `consumers/account/${customerId}/contacts/${contactId}/${action}`, method: '', body: {} }).pipe(
            map(res => {
                return res;
            })
        );
    }
}
